// Use this to implement site-specific methods

export default class FlevoziekenhuisController {
    constructor() {
        this.addTableWrapper();
    }

    addTableWrapper() {
        document.querySelectorAll(`.rt table`).forEach((table) => {
            if (!table.closest(`.tableWrapper`)) {
                const wrapper = document.createElement(`div`);
                wrapper.classList.add(`tableWrapper`);

                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            }
        });
    }
}
